module.exports = __webpack_public_path__ + "img/close.2c5552a1.svg";